export const ValidatorChannelMask = function(rules, value, callback) {
    const reg = /^\d+([,]\d+)*$/;
    if (!reg.test(String(value))) {
        callback(new Error($t('integration.multiple_combined_numbers_are_separated_by_commas_and_are_numbers')));
    } else {
        let array = value.split(',');
        for (let item of array) {
            if (parseInt(item) > 255 || parseInt(item) < 1) {
                callback('存在不在1-255范围的值');
            }
        }
        callback();
    }
};

export const ValidatorCheckNumber = function(rules, value, callback) {
    // let reg = /^\+?[1-9]\d{0,7}(\.\d*)?$/
    let reg = /^\d{1,}$/;
    if (parseInt(value) > 16777215 || parseInt(value) < 1) {
        callback('范围值在1-167771215');
    } else if (!reg.test(value)) {
        callback($t('integration.only_numbers_can_be_entered'));
    } else {
        callback();
    }
};
